/** Перенаправляет браузер на страницу входа с полной перезагрузкой приложения */
export const redirectToAuth = (): void => {
    window.location.href = '/auth';
};
